import React from "react";
import ContactEditForm from "../forms/ContactEditForm";
import ContactInfoView from "./ContactInfoView";
import { Drawer, Container, Flex, Card, CardActionArea, CardHeader, CardContent, CardActions, Input, Chip, Spinner, IconButton} from "@airbus/components-react";
import { Delete, Edit, Cancel} from "@airbus/icons/react";
import eventBus from "../eventBus/EventBus";
import ModalMessageBox from "../components/ModalMessageBox";
import Subscription from "../models/Subscription";


//CONTROLLER
import { ContactController } from "../controller/ContactController";


class ContactsView extends React.Component {

    constructor(props){
        super(props);

        this.filtered_contacts = [];    //init filtered data
        this.contacts = [];             //init list of contacts        
        
        this.subscription = new Subscription();

        //States
        this.state={
            contacts : this.filtered_contacts,  //List of contacts from API
            contactedit : null,     //Edited contact
            contactinfo : null,     //contact: view more
            drawerDetailsOpen: false,           //Display Configuration details
            drawerDetailsAnchor:'right',        //Configuration details Position
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height
            openModal: false,
            spinner: true,
            spinnerDrawer: false,
        }

        //Notification params
        this.setNotification=this.props.notificationHandler;  //call parent notification handler

        //Modal Box
        this.title = null;
        this.message = null;
        this.description = null;
        this.onConfirmCallback = null;
        this.onCancelCallback = null;
        


    }

    /*Handle screen size*/
    handleResize = (e) => {
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    
        };

    async componentDidMount() {

        //Manage screen size
        window.addEventListener("resize", this.handleResize);

        //Retrieve Contacts

        await this.getContacts();     
        
        //Listener Go back to list view after submit update Contact
        eventBus.on("contactlistview", (data) => {          
            if(data['contactlistview'] === true){
                this.getContacts();
                this.setState({ contactedit: null }) //set state to go back to list view

                //Display success banner
                this.setNotification(true,{
                    notifVariant: "success",
                    notifMessage:"Contact modifié avec succès",
                    notifDescription: null
                  });

            }

        
        });

        this.setState({spinner:false});


    }


    componentWillUnmount() {
        //Manage screen size
        window.addEventListener("resize", this.handleResize);
  
      }

    /**
     * RENDERING
     * @returns dom
     */
     render() { return(
        <Container style={{height:this.state.windowHeight-150, paddingTop:"10px"}}>
            
            
            {/**SPINNER WAIT */}
            {this.state.spinner &&
            <Flex justify="left"style={{paddingTop:"25px"}}>
                <Spinner dots/>
            </Flex>
            }

            {/* HANDLE MODAL BOX */}
            
            <ModalMessageBox 
                title={this.title}
                message={this.message}
                description={this.description}
                open={this.state.openModal}
                onConfirmCallback={this.onConfirmCallback}
                onCancelCallback={this.onCancelCallback}

            />
            
            

            {/* HANDLE SEARCH */}
            

            {/* CONTACTS DISPLAY */}
            {!this.state.contactedit  && !this.state.spinner &&
                <div >
                    <Container until='xl'>
                        <Input style={{width:'150px'}} placeholder="Rechercher" onChange={this.handleChangeSearch}/>
                    </Container>
                    
                    <Container until='xl'>
                    <Flex wrap justify='left' spacing='2-x'>

                    {this.state.contacts.map((key, i)=>(
                
                        <Card 
                            style={{width:'300px', height:'200px'}}
                            key={'card-'+i} 
                            translate        
                        >
                        <CardActionArea onClick={()=>{this.onUserDetailClick(key.id)}}>
                            <CardHeader
                                title={key.nom+' '+key.prenom}
                                key = {'header-'+i}
                            />
                            <CardContent>
                                <p>
                                    <b>mail: </b>{key.mail}
                                </p>
                                <p>
                                    <b>tel: </b>{key.telephone}
                                </p>
                                
                            </CardContent>
                        </CardActionArea>
                        <CardActions>
                            <Chip
                                label=""
                                icon={<Edit />}
                                clickable
                                variant={"warning"}
                                onClick={() =>{this.onModifyContactClick(key.id)}}
                            />

                            <Chip
                                label=""
                                icon={<Delete />}
                                clickable
                                variant={"error"}
                                onClick={() =>{this.onDeleteContactClick(key.id, key.nom+' '+key.prenom)}}
                            />
                        </CardActions>
                        </Card>

                    ))};

                    </Flex>

                    </Container>

                </div>
            }

            {/* CONTACT DETAIL DISPLAY */}
            <Drawer  open={this.state.drawerDetailsOpen} theme='light' anchor={this.state.drawerDetailsAnchor} onClose={() => this.setState({drawerDetailsOpen:false})}>
                <div  style={{
                    [this.state.drawerDetailsAnchor === "left" || this.state.drawerDetailsAnchor === "right" ? "width" : "height"]: 750,
                    padding: 16,
                    overflowX:'hidden',
                    overflowY:'auto',
                    paddingTop: 140,
                    maxWidth: this.state.windowWidth
                }}>
                    {/**Close */}
                    <div><IconButton variant="ghost" style={{color:'red'}} onClick={()=>this.setState({drawerDetailsOpen:false})}><Cancel /></IconButton></div>
                    
                    {/**SPINNER WAIT */}
                    {this.state.spinnerDrawer &&
                        <Container until='xl'>
                        <Flex justify="left"style={{paddingTop:"25px"}}>
                            <Spinner dots/>
                        </Flex>
                        </Container>
                    }

                    {this.state.contactinfo !== null &&
                    <Container until='xl'>
                        
                        <ContactInfoView id={this.state.contactinfo.id}
                            name={this.state.contactinfo.nom}
                            firstname={this.state.contactinfo.prenom}
                            mail={this.state.contactinfo.mail}
                            phone={this.state.contactinfo.telephone}
                            adresse1={this.state.contactinfo.adresse1}
                            adresse2={this.state.contactinfo.adresse2}
                            postcode = {this.state.contactinfo.codepostal}
                            city = {this.state.contactinfo.ville}
                            comment = {this.state.contactinfo.commentaire}
                            subscriptions={this.state.contactinfo.subscriptions}
                            />
                    </Container>
                    
                    }

                    
                        <br/>
                        <br/> 
                        <br/>
                    
                
                
                </div>
            </Drawer>


            {/* EDIT CONTACT DISPLAY */}
            {this.state.contactedit &&
                <ContactEditForm id={this.state.contactedit.id}
                            name={this.state.contactedit.nom}
                            firstname={this.state.contactedit.prenom}
                            mail={this.state.contactedit.mail}
                            phone={this.state.contactedit.telephone}
                            adresse1={this.state.contactedit.adresse1}
                            adresse2={this.state.contactedit.adresse2}
                            postcode = {this.state.contactedit.codepostal}
                            city = {this.state.contactedit.ville}
                            comment = {this.state.contactedit.commentaire}
                            notificationHandler = {this.setNotification}
                            />
            }

            
        </Container>
     )}


     /*
     * FUNCTIONS 
     */
    
    //get contacts list
    getContacts= async() => {

        try{
            const response = await new ContactController().getContacts();

            if (response === undefined){

              //erreur API call
              this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"API erreur: Erreur lors de la récupération des données",
                notifDescription:null
              });

            }
            else if (response.response === "200"){
                this.contacts = response.dataArray;
                this.filtered_contacts = response.dataArray;
                this.setState({contacts: this.filtered_contacts});
            }
            else{
                this.setState({contacts: [] });

                //API return <> 200
                this.setNotification(true,{
                    notifVariant: "error",
                    notifMessage:"API erreur: Erreur lors de la récupération des données",
                    notifDescription: response.response+": "+response.responseDescription
                  });
                
            }
        }
        catch(err){
            console.log(err);
        }

    }

    //get contact by id
    getContactById = async(id) =>{
        try{
            
            const response = await new ContactController().getContactByID(id);
            
            if (response === undefined){
                //Fire notification
                this.setNotification(true,{
                    notifVariant: "error",
                    notifMessage:"API Erreur: Impossible de récupérer les informations du contact",
                    notifDescription: null
                  });
                
                return null
            }
            else if (response.response === "200"){
    
                return await response.dataArray;
    
            }
            else{
                this.setState({contacts: [] });
    
                //Fire notification
                this.setNotification(true,{
                    notifVariant: "error",
                    notifMessage:"Erreur lors de la récupération du contact",
                    notifDescription: response.response+": "+response.responseDescription
                  });
                
                return null;
    
            }
        }
        catch(err){
            console.log(err);
        }
    }

    //delete contact
    deleteContact = async(id) =>{
        try{
            const response = await new ContactController().deleteContact(id);
    
            if (response === undefined){
                //Fire notification
                this.setNotification(true,{
                    notifVariant: "error",
                    notifMessage:"API Erreur: le contact n'a pas pu être supprimé",
                    notifDescription: null
                  });
            }
            else if (response.response === "200"){
                
                //Fire notification
                this.setNotification(true,{
                    notifVariant: "success",
                    notifMessage:"Contact supprimé avec succès",
                    notifDescription: null
                  });
                    
            }
            else{
                this.setState({contacts: [] });
    
                //Fire notification
                this.setNotification(true,{
                    notifVariant: "error",
                    notifMessage:"Erreur lors de la suppression du contact",
                    notifDescription: response.response+": "+response.responseDescription
                  });
            }
        }
        catch(err){
            console.log(err);
        }
    }

   
    /****
     * EVENTS
     * */

    //On click "modifier"
    onModifyContactClick = async (id) => {
           
      //retrieve contact information
      let contactData = await this.getContactById(id);
      
      //Fire Edition form by changing state
      this.setState({contactedit:contactData});

    }

    //On click "delete"
    onDeleteContactClick = (id, name) => {
        //debugger;
        this.title="Suppression";
        this.message="L'utilisateur "+name+" va être supprimé. Cette action est irréversible. Voulez-vous continuer ?";
        this.description=null;
        this.onConfirmCallback=this.onConfirmContactDelete.bind(this, id);
        this.onCancelCallback=()=>{this.setState({openModal:false})}
        this.setState({openModal:true});

    }

    /**
     * COnfirm contact deletion
     * @param {string} id user id
     */
    onConfirmContactDelete=(id)=>{
        //debugger;
        //console.log(id);
        this.deleteContact(id);
        this.getContacts();
        this.setState({openModal:false});
    }

    
    //On click Card detail display
    onUserDetailClick = async (id) => {
        let _ = require("underscore");

        this.setState({drawerDetailsOpen: true, spinnerDrawer: true, contactinfo:null});

        let contactData = await this.getContactById(id);

        

        //Get linked subscriptions
        let userCategories = await this.subscription.getCategoriesByContactId(id);
        userCategories = _.sortBy(userCategories, 'category');

        if(contactData){
            contactData['subscriptions']=userCategories
        }
        

        this.setState({contactinfo : contactData, spinnerDrawer:false});
        

    }

    //Handle on change search input box
    handleChangeSearch=(event) =>{
        const value = event.target.value;

        //Filter Data Table
        let _ = require('underscore');
        let filtered_data = _.filter(this.contacts,function(item){

            let found=false;
            Object.keys(item).forEach(function(key) {
                
                if (item[key] === undefined){
                    /*skip undefined keys*/
                }
                
                else if(!isNaN(item[key]) || !isNaN(value) ){
                    
                    
                    if(item[key].toString().includes(value.toString())===true){
                        found = true;

                    }
                }
                else if(item[key].toLowerCase().includes(value.toLowerCase())===true){
                    found = true;
                }
                
            });
            return found === true;

        });

        this.filtered_data=filtered_data; //update filtered data    

        if (this.filtered_data.length > 0){
            this.setState({contacts: filtered_data})
        }else{
            this.setState({contacts: []})
        }


        
    }

}
export default ContactsView;